import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import style from "../RelatedBlogs.module.scss";
import BlogCard from "@/components/page-modules/home-page/BlogSection/shared/Card";
import { RelatedBlogsType } from "@/components/page-modules/blog/data/blog.types";
export const RelatedBlogs: React.FC<RelatedBlogsType> = ({
  title,
  blogs
}) => {
  const isMobile = useMediaQuery({
    maxWidth: 720
  });
  return <section className={style.related__blogs} data-sentry-component="RelatedBlogs" data-sentry-source-file="RelatedBlogs.tsx">
      <div className={style.title} style={{
      fontSize: !isMobile ? "32px" : "20px"
    }}>
        {title}
      </div>

      {isMobile ? <div>
          <Swiper spaceBetween={20} slidesPerView={1} roundLengths effect="fade" style={{
        width: `${isMobile ? "302px" : "306px"}`,
        overflow: "visible",
        paddingBottom: "4px",
        marginTop: "24px"
      }}>
            {blogs.map(item => <SwiperSlide key={item.blogId}>
                <BlogCard blogData={item} key={item.blogId} />
              </SwiperSlide>)}
          </Swiper>
        </div> : <div className={style.cards__wrapper}>
          {blogs.map(item => <BlogCard blogData={item} key={item.blogId} />)}
        </div>}
    </section>;
};